import React, { useState } from 'react';

import { FormControl, TextField } from '@mui/material';

import { incidentDetailState, useResolveCallback, useGotoListPageCallback } from '../../states/incidents';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { H2 } from '../../components/Heading';
import { useRecoilValue } from 'recoil';

export default function IncidentResolutionContainer() {
  const selectedIncident = useRecoilValue(incidentDetailState);

  const [open, setOpen] = React.useState(false);
  const [resolveStatus, setResolveStatus] = useState('RESOLVED');
  const [resolution, setResolution] = useState();
  const resolve = useResolveCallback();
  const gotoList = useGotoListPageCallback();

  const handleClose = () => {
    setOpen(false);
    setResolution('');
  };

  const markIncident = (status) => {
    setOpen(true);
    setResolveStatus(status);
  };

  const markNoIssueWithAddress = (status) => {
    const statusType = 'NO_ISSUE_ADDRESS';
    resolve(status, undefined, statusType).then(() => {
      gotoList();
    });
  };

  const resolveIncident = () => {
    resolve(resolveStatus, resolution).then(() => {
      handleClose();
      gotoList();
    });
  };

  if (!selectedIncident) return <div></div>;

  return (
    <div>
      {selectedIncident.status !== 'CREATED' && <code>{selectedIncident.status}</code>}
      {selectedIncident.status !== 'RESOLVED' && (
        <>
          <Button variant="contained" disableElevation style={{ marginLeft: '10px' }} color="primary" onClick={() => markIncident('RESOLVED')}>
            Resolved - Valid
          </Button>
          <Button variant="contained" disableElevation style={{ marginLeft: '10px', backgroundColor: '#e0e0e0', color: '#4a4a4a' }} onClick={() => markNoIssueWithAddress('RESOLVED')}>
            Resolved - No Issue with Address
          </Button>
        </>
      )}
      {selectedIncident.status !== 'UNSOLVABLE' && (
        <Button variant="contained" disableElevation style={{ marginLeft: '10px' }} color="error" onClick={() => markIncident('UNSOLVABLE')}>
          Mark as Unsolvable
        </Button>
      )}
      {selectedIncident.status !== 'DISPATCH_FOLLOWUP' && (
        <Button variant="contained" disableElevation style={{ marginLeft: '10px', backgroundColor: '#e0e0e0', color: '#4a4a4a' }} onClick={() => markIncident('DISPATCH_FOLLOWUP')}>
          DISPATCH FOLLOW-UP
        </Button>
      )}
      <Dialog maxWidth="md" open={open} keepMounted onClose={handleClose} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle>
          <H2>
            Mark Incident as <strong>{resolveStatus}</strong>
          </H2>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth>
            <TextField multiline={true} fullWidth variant={'outlined'} minRows={4} placeholder="Resolution" onChange={(e) => setResolution(e.target.value)} />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={resolveIncident} variant="contained" color="primary">
            Save
          </Button>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
